import { jsx as _jsx } from "react/jsx-runtime";
import styles from './styles.module.css';
import { cn } from "@/utils/theme/cn";
const variants = {
    default: 'bg-[#888888] rounded-xl',
    circle: 'rounded-full aspect-square w-8',
    text: 'h-1 w-8'
};
export default function Skeleton(param) {
    let { className, variant, opacity = 50 } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: cn(styles["holder".concat(opacity)], variants.default, variants[variant], className)
    });
}
